module.exports = __webpack_public_path__ + "img/hibob.81456b6e.svg";